'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hovered", "use", "_useNativeButton", "active"];
import { BATTLESHIP, FLINT } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIClickable from 'UIComponents/button/UIClickable';
import HoverProvider from 'UIComponents/providers/HoverProvider';
import { setUiTransition } from 'UIComponents/utils/Styles';
import { jsx as _jsx } from "react/jsx-runtime";
const getBorderColor = ({
  'aria-pressed': ariaPressed,
  hovered,
  active,
  disabled
}) => {
  if (!disabled) {
    if (ariaPressed || active) return FLINT;
    if (hovered) return BATTLESHIP;
  }
  return 'transparent';
};
const Clickable = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UIClickable, Object.assign({}, rest));
}).withConfig({
  displayName: "SimpleStyledClickable__Clickable",
  componentId: "xyibu1-0"
})(["background:", ";border:1px solid ", ";border-radius:3px;display:inline-block;height:27px;padding:0 4px 0 4px;vertical-align:middle;", ";&&{cursor:", ";}"], ({
  'aria-pressed': ariaPressed,
  active
}) => ariaPressed || active ? BATTLESHIP : '', getBorderColor, setUiTransition(), ({
  disabled
}) => disabled ? 'not-allowed' : 'initial');
const SimpleStyledClickable = props => /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, props, {
  children: hoverProviderProps => /*#__PURE__*/_jsx(Clickable, Object.assign({}, props, hoverProviderProps))
}));
SimpleStyledClickable.displayName = 'SimpleStyledClickable';
export default SimpleStyledClickable;